module.exports = __webpack_public_path__ + "static/Caramel-469fe77de2fd7149ee2ba3e763090148.png";